package one.healthium.ricediet

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp
import ifaandroid.apps.ricediet.composeapp.generated.resources.Res
import ifaandroid.apps.ricediet.composeapp.generated.resources.poppins_bold
import ifaandroid.apps.ricediet.composeapp.generated.resources.poppins_extrabold
import ifaandroid.apps.ricediet.composeapp.generated.resources.poppins_light
import ifaandroid.apps.ricediet.composeapp.generated.resources.poppins_medium
import ifaandroid.apps.ricediet.composeapp.generated.resources.poppins_regular
import ifaandroid.apps.ricediet.composeapp.generated.resources.poppins_semibold
import one.healthium.ui.compose.theme.AppTextStyle
import one.healthium.ui.compose.theme.AppThemeBase
import one.healthium.ui.compose.theme.Colors
import one.healthium.ui.compose.theme.Shapes
import one.healthium.ui.compose.theme.black50
import one.healthium.ui.compose.theme.gray_20
import one.healthium.ui.compose.theme.styles.AppButtonStyle
import one.healthium.ui.compose.theme.styles.AppButtonStyleRef
import one.healthium.ui.compose.theme.styles.AppNavigationBarStyle
import one.healthium.ui.compose.theme.styles.AppNavigationRailStyle
import one.healthium.ui.compose.theme.styles.ChartStyle
import one.healthium.ui.compose.theme.styles.DailyTaskItemStyle
import one.healthium.ui.compose.theme.styles.DailyTaskStyle
import one.healthium.ui.compose.theme.styles.LogWaterControlStyle
import one.healthium.ui.compose.theme.styles.ProfileStyle
import one.healthium.ui.compose.theme.white
import one.healthium.ui.compose.theme.yellow
import org.jetbrains.compose.resources.Font

@Composable
internal fun rice() = AppThemeBase(
    colors = Colors.rice,
    shapes = Shapes.carni,
    dailyTasksStyle = DailyTaskStyle(
        itemStyle = DailyTaskItemStyle.V2(
            iconTint = Colors.rice.primary.copy(alpha = 0.5f),
        )
    ),
    textStyles = AppTextStyle(
        fontFamily = PoppinsFontFamily,
        fontFamilySecondary = PoppinsFontFamily,
        fontFamilyTertiary = null,
        textField = TextStyle(
            fontFamily = PoppinsFontFamily,
            fontSize = 38.sp,
            fontWeight = FontWeight.Light,
        ),
    ),
    defaultButtonStyle = AppButtonStyle(
        containerColor = yellow,
        contentColor = black50,
    ),
    logWaterControlStyle = LogWaterControlStyle(
        saveButtonStyleRef = AppButtonStyleRef.Default
    ),
    profileStyle = ProfileStyle(
        weightProgressBarStyle = ChartStyle(
            barColor = white,
            highlightedBarColor = Colors.rice.primary
        ),
        weightProgressChartStyle = ChartStyle(
            barColor = gray_20,
            highlightedBarColor = Colors.rice.primary
        ),
        caloriesChartStyle = ChartStyle(
            barColor = gray_20,
            highlightedBarColor = Colors.rice.primary
        ),
        avatarContainerColor = Colors.rice.tertiary,
        avatarContentColor = white,
    ),
    navigationBarStyle = AppNavigationBarStyle(
        containerColor = Colors.rice.primary,
        defaultLabelColor = white,
        activeLabelColor = yellow,
    ),
    navigationRailStyle = AppNavigationRailStyle(
        containerColor = Colors.rice.primary,
        defaultLabelColor = white,
        activeLabelColor = yellow,
    ),
)

private val PoppinsFontFamily
    @Composable get() = FontFamily(
        Font(Res.font.poppins_light, FontWeight.Light),
        Font(Res.font.poppins_regular, FontWeight.Normal),
        Font(Res.font.poppins_medium, FontWeight.Medium),
        Font(Res.font.poppins_semibold, FontWeight.SemiBold),
        Font(Res.font.poppins_bold, FontWeight.Bold),
        Font(Res.font.poppins_extrabold, FontWeight.ExtraBold),
    )
